import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';

import { formStore } from '@/stores/form.js';
import { voertuigStore } from '@/stores/voertuig.js';

export function useTitleSectionContents() {
  const { t, te } = useI18n();
  const { funnelEntry, stepKey } = formStore();
  const { merk, getHasVehicle, getType } = storeToRefs(voertuigStore());
  const funnelEntries = ['aansprakelijkheid', 'inboedel', 'woonhuis', 'gezinsongevallen', 'doorlopendeReis', 'rechtsbijstand'];
  const funnelKey = funnelEntries.includes(funnelEntry) ? 'voordeelpakket' : funnelEntry;
  const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1).toLowerCase();
  const translatedTitlePlain = () => {
    return te(`form-steps.${funnelKey}.${stepKey}.header-title-plain`)
      ? t(`form-steps.${funnelKey}.${stepKey}.header-title-plain`, {
          tagopen: '<span data-wg-notranslate>',
          tagclose: '</span>',
          funnelType: funnelEntry.toLowerCase(),
        })
      : t(`form-steps.general.${stepKey}.header-title-plain`, {
          tagopen: '<span>',
          tagclose: '</span>',
          funnelType: funnelEntry.toLowerCase(),
        });
  };

  const translatedTitleVehicle = () => {
    return te(`form-steps.${funnelEntry}.${stepKey}.header-title`)
      ? t(`form-steps.${funnelEntry}.${stepKey}.header-title`, {
          tagopen: '<span data-wg-notranslate>',
          tagclose: '</span>',
          vehicle: `${capitalize(merk.value)} ${capitalize(getType.value)}`,
        })
      : t(`form-steps.general.${stepKey}.header-title`, {
          tagopen: '<span data-wg-notranslate>',
          tagclose: '</span>',
          vehicle: `${capitalize(merk.value)} ${capitalize(getType.value)}`,
        });
  };

  const translatedBodyPlain = () => {
    return te(`form-steps.${funnelKey}.${stepKey}.header-body-plain`)
      ? t(`form-steps.${funnelKey}.${stepKey}.header-body-plain`)
      : t(`form-steps.general.${stepKey}.header-body-plain`);
  };

  const translatedBodyVehicle = () => {
    return te(`form-steps.${funnelEntry}.${stepKey}.header-body`)
      ? t(`form-steps.${funnelEntry}.${stepKey}.header-body`, {
          tagopen: '<span data-wg-notranslate>',
          tagclose: '</span>',
          vehicle: `${capitalize(merk.value)} ${capitalize(getType.value)}`,
        })
      : t(`form-steps.general.${stepKey}.header-body`, {
          tagopen: '<span data-wg-notranslate>',
          tagclose: '</span>',
          vehicle: `${capitalize(merk.value)} ${capitalize(getType.value)}`,
        });
  };

  const renderedTitle = () => {
    return getHasVehicle.value ? translatedTitleVehicle() : translatedTitlePlain();
  };

  const renderedBody = () => {
    return getHasVehicle.value ? translatedBodyVehicle() : translatedBodyPlain();
  };

  return { renderedTitle, renderedBody };
}
